export interface StakingVaultResponse {
  id: number;
  label: string;
  dayNumber: number;
  rewardPercent: number;
  minStake: number;
}

export enum StakingStatus {
  STAKING = 'STAKING',
  CANCEL = 'CANCEL',
}

export interface UserStakingResponse {
  id: number;
  stakingVaultDto: StakingVaultResponse;
  stakeAmount: string;
  rewardAmount: string;
  claimDate: string;
  status: StakingStatus;
  claimHistory: ClaimHistory[];
}

export interface StakeRequest {
  vaultId: number;
  amount: number;
}

export interface ClaimHistory {
  id: number;
  claimAmount: string;
  claimDate: string;
}
